import { render } from "./attendee.index.vue?vue&type=template&id=ea8f0cec"
import script from "./attendee.index.vue?vue&type=script&lang=js"
export * from "./attendee.index.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__